/**
 * Pronunciation Mapping for Speech Therapy Tests
 * 
 * This file contains mappings between mispronunciations and the specific sounds (lauts)
 * that are problematic. When a child mispronounces a word, we can identify which 
 * sounds they're having trouble with.
 */

export const PRONUNCIATION_TESTS = {
  'Gießkanne': {
    targetWord: 'Gießkanne',
    displayWord: 'Gießkanne',
    mispronunciations: {
      'Distanne': {
        displayText: 'Distanne',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G', 'K'],  // Ages < 3.5: mild problems
          severe: ['G', 'K'] // Ages >= 3.5: severe problems
        }
      },
      'Dieftanne': {
        displayText: 'Dieftanne',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G', 'S'],
          severe: ['G', 'S']
        }
      },
      'Giestanne': {
        displayText: 'Giestanne',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Gießkanne': {
        displayText: 'Gießkanne',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      },
      'Dieskanne': {
        displayText: 'Dieskanne',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G'],
          severe: ['G']
        }
      }
    }
  },
  'Marienkäfer': {
    targetWord: 'Marienkäfer',
    displayWord: 'Marienkäfer',
    mispronunciations: {
      'Mahinkäfer': {
        displayText: 'Mahinkäfer',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Marintäfer': {
        displayText: 'Marintäfer',
        borderAge: 12,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Masinkäfer': {
        displayText: 'Masinkäfer',
        borderAge: 12,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      }
    }
  },
  'Telefon': {
    targetWord: 'Telefon',
    displayWord: 'Telefon',
    mispronunciations: {
      'Telehon': {
        displayText: 'Telehon',
        borderAge: 12,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      },
      'Tiselon': {
        displayText: 'Tiselon',
        borderAge: 12,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      },
      'Teleson': {
        displayText: 'Teleson',
        borderAge: 12,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      },
      'Telelon': {
        displayText: 'Telelon',
        borderAge: 12,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      }
    }
  },
  'Hase': {
    targetWord: 'Hase',
    displayWord: 'Hase',
    mispronunciations: {
      'Lase': {
        displayText: 'Lase',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Hase': {
        displayText: 'Hase',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      },
      'Hafe': {
        displayText: 'Hafe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      }
    }
  },
  'Katze': {
    targetWord: 'Katze',
    displayWord: 'Katze',
    mispronunciations: {
      'Tatse': {
        displayText: 'Tatse',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Datse': {
        displayText: 'Datse',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Gatse': {
        displayText: 'Gatse',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      }
    }
  },
  'Eichhörnchen': {
    targetWord: 'Eichhörnchen',
    displayWord: 'Eichhörnchen',
    mispronunciations: {
      'Eihönchen': {
        displayText: 'Eihönchen',
        borderAge: 4,
        problematicSounds: {
          mild: ['CH'],
          severe: ['CH']
        }
      },
      'Eihörnsen': {
        displayText: 'Eihörnsen',
        borderAge: 4,
        problematicSounds: {
          mild: ['CH'],
          severe: ['CH']
        }
      },
      'Eishörnsen': {
        displayText: 'Eishörnsen',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['CH'],
          severe: ['CH']
        }
      }
    }
  },
  'Löwe': {
    targetWord: 'Löwe',
    displayWord: 'Löwe',
    mispronunciations: {
      'Höwe': {
        displayText: 'Höwe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Löfe': {
        displayText: 'Löfe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['W'],
          severe: ['W']
        }
      },
      'Löse': {
        displayText: 'Löse',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['W'],
          severe: ['W']
        }
      }
    }
  },
  'Rutsche': {
    targetWord: 'Rutsche',
    displayWord: 'Rutsche',
    mispronunciations: {
      'Hutsche': {
        displayText: 'Hutsche',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Lutsche': {
        displayText: 'Lutsche',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Lutse': {
        displayText: 'Lutse',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R','SCH'],
          severe: ['R','SCH']
        }
      },
      'Rutse': {
        displayText: 'Rutse',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      }
    }
  },
  'Becher': {
    targetWord: 'Becher',
    displayWord: 'Becher',
    mispronunciations: {
      'Besa': {
        displayText: 'Besa',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['CH','SCH'],
          severe: ['CH','SCH']
        }
      },
      'Pesa': {
        displayText: 'Pesa',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['B','S','CH'],
          severe: ['B','S','CH']
        }
      }
    }
  },
  'Knöpfe': {
    targetWord: 'Knöpfe',
    displayWord: 'Knöpfe',
    mispronunciations: {
      'Höpfe': {
        displayText: 'Höpfe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Nöpfe': {
        displayText: 'Nöpfe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Knötse': {
        displayText: 'Knötse',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      },
      'Knöse': {
        displayText: 'Knöse',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      },
      'Tnötpfe': {
        displayText: 'Tnötpfe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      }
    }
  },
  'Drei': {
    targetWord: 'Drei',
    displayWord: 'Drei',
    mispronunciations: {
      'Dai': {
        displayText: 'Dai',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Grei': {
        displayText: 'Grei',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['G']
        }
      },
      'Gai': {
        displayText: 'Gai',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      }
    }
  },
  'Flasche': {
    targetWord: 'Flasche',
    displayWord: 'Flasche',
    mispronunciations: {
      'Flase': {
        displayText: 'Flase',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Lasche': {
        displayText: 'Lasche',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      },
      'Lase': {
        displayText: 'Lase',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F', 'SCH'],
          severe: ['F', 'SCH']
        }
      },
      'Fasche': {
        displayText: 'Fasche',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Flahe': {
        displayText: 'Flahe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Fase': {
        displayText: 'Fase',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L', 'SCH'],
          severe: ['L', 'SCH']
        }
      },
      'Sase': {
        displayText: 'Sase',
        borderAge: 4,
        problematicSounds: {
          mild: ['SCH', 'F'],
          severe: ['SCH', 'F']
        }
      },
      'Sasche': {
        displayText: 'Sasche',
        borderAge: 4,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      }
    }
  },
  'Drache': {
    targetWord: 'Drache',
    displayWord: 'Drache',
    mispronunciations: {
      'Dache': {
        displayText: 'Dache',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Dase': {
        displayText: 'Dase',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['CH'],
          severe: ['CH']
        }
      },
      'Gache': {
        displayText: 'Gache',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['D', 'R'],
          severe: ['D', 'R']
        }
      },
      'Tache': {
        displayText: 'Tache',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Tase': {
        displayText: 'Tase',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      }
    }
  },
  'Krokodil': {
    targetWord: 'Krokodil',
    displayWord: 'Krokodil',
    mispronunciations: {
      'Totodil': {
        displayText: 'Totodil',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K', 'KR'],
          severe: ['K', 'KR']
        }
      },
      'Tosodil': {
        displayText: 'Tosodil',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Krokogil': {
        displayText: 'Krokogil',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['D'],
          severe: ['D']
        }
      }
    }
  },
  'Gespenst': {
    targetWord: 'Gespenst',
    displayWord: 'Gespenst',
    mispronunciations: {
      'Depenst': {
        displayText: 'Depenst',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G', 'SCH'],
          severe: ['G', 'SCH']
        }
      },
      'Spens': {
        displayText: 'Spens',
        borderAge: 4,
        problematicSounds: {
          mild: ['G', 'SCH'],
          severe: ['G', 'SCH']
        }
      },
      'Kepenst': {
        displayText: 'Kepenst',
        borderAge: 4,
        problematicSounds: {
          mild: ['G', 'SCH'],
          severe: ['G', 'SCH']
        }
      }
    }
  },
  'Elefant': {
    targetWord: 'Elefant',
    displayWord: 'Elefant',
    mispronunciations: {
      'Efelant': {
        displayText: 'Efelant',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F'],
          severe: ['L']
        }
      },
      'Fant': {
        displayText: 'Fant',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Efant': {
        displayText: 'Efant',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Eselant': {
        displayText: 'Eselant',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      }
    }
  },
  'Schmetterling': {
    targetWord: 'Schmetterling',
    displayWord: 'Schmetterling',
    mispronunciations: {
      'Smetaling': {
        displayText: 'Smetaling',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Metaling': {
        displayText: 'Metaling',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Mekaling': {
        displayText: 'Mekaling',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Schmekaling': {
        displayText: 'Schmekaling',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['T'],
          severe: ['T']
        }
      },
      'Smekaling': {
        displayText: 'Smekaling',
        borderAge: 4,
        problematicSounds: {
          mild: ['SCH', 'K', 'G'],
          severe: ['SCH', 'K', 'G']
        }
      }
    }
  },
  'Bücher': {
    targetWord: 'Bücher',
    displayWord: 'Bücher',
    mispronunciations: {
      'Büta': {
        displayText: 'Büta',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['CH'],
          severe: ['CH']
        }
      },
      'Büsa': {
        displayText: 'Büsa',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['CH'],
          severe: ['CH']
        }
      }
    }
  },
  'Schiff': {
    targetWord: 'Schiff',
    displayWord: 'Schiff',
    mispronunciations: {
      'Fiff': {
        displayText: 'Fiff',
        borderAge: 12,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Siff': {
        displayText: 'Siff',
        borderAge: 12,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Tiff': {
        displayText: 'Tiff',
        borderAge: 12,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      }
    }
  },
  'Trampolin': {
    targetWord: 'Trampolin',
    displayWord: 'Trampolin',
    mispronunciations: {
      'Hampolin': {
        displayText: 'Hampolin',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['T', 'R'],
          severe: ['T', 'R']
        }
      },
      'Krampolin': {
        displayText: 'Krampolin',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['T'],
          severe: ['T']
        }
      },
      'Tambolin': {
        displayText: 'Tambolin',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R', 'P'],
          severe: ['R', 'P']
        }
      }
    }
  },
  'Kaputt': {
    targetWord: 'Kaputt',
    displayWord: 'Kaputt',
    mispronunciations: {
      'Taputt': {
        displayText: 'Taputt',
        borderAge: 3,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Kapu': {
        displayText: 'Kapu',
        borderAge: 3,
        problematicSounds: {
          mild: ['T'],
          severe: ['T']
        }
      },
      'Gaputt': {
        displayText: 'Gaputt',
        borderAge: 3,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      },
      'Daputt': {
        displayText: 'Daputt',
        borderAge: 3,
        problematicSounds: {
          mild: ['K'],
          severe: ['K']
        }
      }
    }
  },
  'Frosch': {
    targetWord: 'Frosch',
    displayWord: 'Frosch',
    mispronunciations: {
      'Fros': {
        displayText: 'Fros',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Rosch': {
        displayText: 'Rosch',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      },
      'Sorch': {
        displayText: 'Sorch',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['R', 'SCH'],
          severe: ['R', 'SCH']
        }
      }
    }
  },
  'Schlüssel': {
    targetWord: 'Schlüssel',
    displayWord: 'Schlüssel',
    mispronunciations: {
      'Lüssel': {
        displayText: 'Lüssel',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Slüssel': {
        displayText: 'Slüssel',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      }
    }
  },
  'Gitarre': {
    targetWord: 'Gitarre',
    displayWord: 'Gitarre',
    mispronunciations: {
      'Githalle': {
        displayText: 'Githalle',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Talle': {
        displayText: 'Talle',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G', 'R'],
          severe: ['G', 'R']
        }
      },
      'Ditarre': {
        displayText: 'Ditarre',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G'],
          severe: ['G']
        }
      },
      'Tarre': {
        displayText: 'Tarre',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G'],
          severe: ['G']
        }
      },
      'Disarre': {
        displayText: 'Disarre',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['T'],
          severe: ['T']
        }
      }
    }
  },
  'Sonne': {
    targetWord: 'Sonne',
    displayWord: 'Sonne',
    mispronunciations: {
      'Sonne': {
        displayText: 'Sonne',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      },
      'Honne': {
        displayText: 'Honne',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      },
      'Tsonne': {
        displayText: 'Tsonne',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      },
      'Schonne': {
        displayText: 'Schonne',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      },
      'Fonne': {
        displayText: 'Fonne',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      },
      'Tonne': {
        displayText: 'Tonne',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['S'],
          severe: ['S']
        }
      }
    }
  },
  'Waschmaschine': {
    targetWord: 'Waschmaschine',
    displayWord: 'Waschmaschine',
    mispronunciations: {
      'Makmakine': {
        displayText: 'Makmakine',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Wasmasine': {
        displayText: 'Wasmasine',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['SCH'],
          severe: ['SCH']
        }
      },
      'Hasmasine': {
        displayText: 'Hasmasine',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['W', 'SCH'],
          severe: ['W', 'SCH']
        }
      }
    }
  },
  'Lampe': {
    targetWord: 'Lampe',
    displayWord: 'Lampe',
    mispronunciations: {
      'Jampe': {
        displayText: 'Jampe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Lambe': {
        displayText: 'Lambe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['P'],
          severe: ['P']
        }
      },
      'Rampe': {
        displayText: 'Rampe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Hampe': {
        displayText: 'Hampe',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      }
    }
  },
  'Roller': {
    targetWord: 'Roller',
    displayWord: 'Roller',
    mispronunciations: {
      'Holla': {
        displayText: 'Holla',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Lolla': {
        displayText: 'Lolla',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Roja': {
        displayText: 'Roja',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      }
    }
  },
  'Luftballon': {
    targetWord: 'Luftballon',
    displayWord: 'Luftballon',
    mispronunciations: {
      'Huftballon': {
        displayText: 'Huftballon',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Luftbajon': {
        displayText: 'Luftbajon',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Juftbajon': {
        displayText: 'Juftbajon',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['L'],
          severe: ['L']
        }
      },
      'Lustballon': {
        displayText: 'Lustballon',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['F'],
          severe: ['F']
        }
      }
    }
  },
  'Tomate': {
    targetWord: 'Tomate',
    displayWord: 'Tomate',
    mispronunciations: {
      'Mate': {
        displayText: 'Mate',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['T'],
          severe: ['T']
        }
      },
      'Komake': {
        displayText: 'Komake',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['T'],
          severe: ['T']
        }
      },
      'Domate': {
        displayText: 'Domate',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['T'],
          severe: ['T']
        }
      }
    }
  },
  'Grün': {
    targetWord: 'Grün',
    displayWord: 'Grün',
    mispronunciations: {
      'Glün': {
        displayText: 'Glün',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Rün': {
        displayText: 'Rün',
        borderAge: 3.5,
        problematicSounds: {
          mild: ['G'],
          severe: ['G']
        }
      },
      'Gün': {
        displayText: 'Gün',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['R'],
          severe: ['R']
        }
      },
      'Drün': {
        displayText: 'Drün',
        borderAge: 3.6,
        problematicSounds: {
          mild: ['G'],
          severe: ['G']
        }
      }
    }
  },
  'Mäppchen': {
    targetWord: 'Mäppchen',
    displayWord: 'Mäppchen',
    mispronunciations: {
      'Mäppsen': {
        displayText: 'Mäppsen',
        borderAge: 4.6,
        problematicSounds: {
          mild: ['CH'],
          severe: ['CH']
        }
      }
    }
  }
};

/**
 * Helper function to get all problematic sounds from a list of selected mispronunciations
 * @param {string} targetWord - The word being tested (e.g., 'Gieskanne')
 * @param {string[]} selectedMispronunciations - Array of mispronunciation selections
 * @param {number} age - Age of the child to determine severity level
 * @returns {string[]} Array of problematic sound strings (e.g., ['G', 'S'])
 */
export function getProblematicSounds(targetWord, selectedMispronunciations, age = null) {
  const testData = PRONUNCIATION_TESTS[targetWord];
  if (!testData) {
    console.warn(`No test data found for word: ${targetWord}`);
    return [];
  }

  const allProblematicSounds = [];
  
  selectedMispronunciations.forEach(mispronunciation => {
    // Skip the 'correct' option
    if (mispronunciation === 'correct') {
      return;
    }
    
    const mispronunciationData = testData.mispronunciations[mispronunciation];
    if (mispronunciationData && mispronunciationData.problematicSounds) {
      let sounds;
      const borderAge = mispronunciationData.borderAge || 3; // Use mispronunciation-specific border age, fallback to 3
      
      // Check if the new age-based structure exists
      if (mispronunciationData.problematicSounds.mild && mispronunciationData.problematicSounds.severe) {
        // Use age-based severity: mild for ages < borderAge, severe for ages >= borderAge
        if (age !== null && age < borderAge) {
          sounds = mispronunciationData.problematicSounds.mild;
        } else {
          sounds = mispronunciationData.problematicSounds.severe;
        }
      } else {
        // Fallback to old structure for backward compatibility
        sounds = mispronunciationData.problematicSounds;
      }
      
      if (Array.isArray(sounds)) {
        allProblematicSounds.push(...sounds);
      }
    }
  });

  // Remove duplicates
  const uniqueProblematicSounds = [...new Set(allProblematicSounds)];

  return uniqueProblematicSounds;
}

/**
 * Helper function to get problematic sounds separated by severity level
 * @param {string} targetWord - The word being tested (e.g., 'Gieskanne')
 * @param {string[]} selectedMispronunciations - Array of mispronunciation selections
 * @param {number} age - Age of the child to determine severity level
 * @returns {Object} Object with mild, severe, and all problematic sounds
 */
export function getProblematicSoundsBySeverity(targetWord, selectedMispronunciations, age = null) {
  const testData = PRONUNCIATION_TESTS[targetWord];
  if (!testData) {
    console.warn(`No test data found for word: ${targetWord}`);
    return { mild: [], severe: [], all: [] };
  }

  const mildSounds = [];
  const severeSounds = [];
  
  selectedMispronunciations.forEach(mispronunciation => {
    // Skip the 'correct' option
    if (mispronunciation === 'correct') {
      return;
    }
    
    const mispronunciationData = testData.mispronunciations[mispronunciation];
    if (mispronunciationData && mispronunciationData.problematicSounds) {
      const borderAge = mispronunciationData.borderAge || 3; // Use mispronunciation-specific border age, fallback to 3
      
      // Check if the new age-based structure exists
      if (mispronunciationData.problematicSounds.mild && mispronunciationData.problematicSounds.severe) {
        // Determine which category this falls into based on age
        if (age !== null && age < borderAge) {
          // Child is young enough that this is a mild issue
          if (Array.isArray(mispronunciationData.problematicSounds.mild)) {
            mildSounds.push(...mispronunciationData.problematicSounds.mild);
          }
        } else {
          // Child is old enough that this is a severe issue
          if (Array.isArray(mispronunciationData.problematicSounds.severe)) {
            severeSounds.push(...mispronunciationData.problematicSounds.severe);
          }
        }
      } else {
        // Fallback to old structure for backward compatibility
        // Assume severe if no age-based structure
        if (Array.isArray(mispronunciationData.problematicSounds)) {
          severeSounds.push(...mispronunciationData.problematicSounds);
        }
      }
    }
  });

  // Remove duplicates
  const uniqueMildSounds = [...new Set(mildSounds)];
  const uniqueSevereSounds = [...new Set(severeSounds)];
  const allSounds = [...new Set([...mildSounds, ...severeSounds])];

  return {
    mild: uniqueMildSounds,
    severe: uniqueSevereSounds,
    all: allSounds
  };
}

/**
 * Helper function to get all available words for testing
 * @returns {string[]} Array of available word strings
 */
export function getAvailableWords() {
  return Object.keys(PRONUNCIATION_TESTS);
}

/**
 * Helper function to get all available mispronunciation options for a word
 * @param {string} targetWord - The word being tested
 * @returns {string[]} Array of mispronunciation option strings
 */
export function getMispronunciationOptions(targetWord) {
  const testData = PRONUNCIATION_TESTS[targetWord];
  if (!testData) {
    return [];
  }

  return Object.keys(testData.mispronunciations);
}

/**
 * Helper function to get display information for a target word
 * @param {string} targetWord - The word being tested
 * @returns {Object} Object with display information
 */
export function getWordDisplayInfo(targetWord) {
  const testData = PRONUNCIATION_TESTS[targetWord];
  if (!testData) {
    return {
      displayWord: targetWord
    };
  }

  return {
    displayWord: testData.displayWord
  };
}

/**
 * Get a summary of all unique problematic sounds from multiple tests
 * @param {Object[]} pronunciationTests - Array of pronunciation test results
 * @returns {Object} Summary object with counts of problematic sounds
 */
export function getSoundProblemSummary(pronunciationTests) {
  const soundProblems = {};
  
  pronunciationTests.forEach(test => {
    // Use the soundIssues directly from the test (no need to recompute)
    const problematicSounds = test.soundIssues || [];
    
    problematicSounds.forEach(sound => {
      if (!soundProblems[sound]) {
        soundProblems[sound] = {
          sound: sound,
          count: 0
        };
      }
      soundProblems[sound].count++;
    });
  });
  
  return soundProblems;
}